import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from "./AuthContext"; 
import LandingPage from './LandingPage';
import DMCAGenerator from './DMCAGenerator';  // ← changed
import Header from './Header';
import { ThemeProvider } from './ThemeContext';
import PricingPage from './PricingPage';
import './App.css';

function AppLayout() {
  const location = useLocation();
  const { user } = useAuth();
  
  const shouldShowHeader = !(location.pathname === '/generate' && user);

  return (
    <div className="App">
      {shouldShowHeader && <Header />}
      
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path='/generate' element={<DMCAGenerator />} />  {/* ← changed */}
        <Route path="/pricing-plans" element={<PricingPage />} />
        {/* QRRedirect route removed */}
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppLayout />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;